import { Box, Dialog, List, ListItem, ListItemText, Tooltip, Typography } from "@material-ui/core";
import ComputerIcon from "@material-ui/icons/Computer";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import React from "react";
import { useSnackbar } from "notistack";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import detectEthereumProvider from "@metamask/detect-provider";

import metamaskLogo from "src/assets/icons/wallets/metamask512.png";
import { updateAccInfo } from "src/redux/slices/account/account-slice";
import { ERR_TOP_CENTER, SUCCESS_TOP_CENTER, INFO_TOP_CENTER } from "src/utils/snackbar-utils";
import { getCurrentNetwork } from "src/web3/network";
import { getCurrentConnectedWallet, setCurrentConnectedWallet, setWeb3Sender, WALLET_IDS } from "src/web3/wallet";
import { addMetaMaskEventListeners, clearMetaMaskEventListeners } from "src/web3/wallet/event-handler/metamask";
import {
  addWalletConnectEventListeners,
  clearWalletConnectEventListeners,
  provider,
} from "src/web3/wallet/event-handler/wallet-connect";
import { switchNetwork } from "src/web3/wallet/network-switcher";
import topImgSrc from "./connect-wallet-top-img.png";
import walletConnectIcon from "./wallet-connect-icon.svg";

const imgStyle = {
  height: 32,
  width: 32,
  objectFit: "contain",
  marginRight: 16,
};

export default function ConnectWalletDialog({ hdClosePopup }) {
  const dp = useDispatch();
  const { enqueueSnackbar: eq } = useSnackbar();

  const currentConnectedWallet = getCurrentConnectedWallet();

  async function hdConnectMetaMask() {
    if (isMobile) return;
    if (currentConnectedWallet === WALLET_IDS.WALLET_CONNECT) {
      clearWalletConnectEventListeners();
    }
    try {
      const chainId = window.ethereum.networkVersion;
      const currentNetwork = getCurrentNetwork();
      if (chainId !== Number(currentNetwork.chainId).toString()) {
        eq(`Please switch to ${currentNetwork.chainName}, then reconnect!`, { ...ERR_TOP_CENTER });
      }
      await switchNetwork(dp, eq);
      const provider = await detectEthereumProvider();
      // If the provider returned by detectEthereumProvider is not the same as
      // window.ethereum, something is overwriting it, perhaps another wallet.
      if (provider !== window.ethereum) {
        console.error("Do you have multiple wallets installed?");
        eq("Do you have multiple wallets installed?", INFO_TOP_CENTER);
      }
      addMetaMaskEventListeners(dp, eq);
      const accountAddress = (await window.ethereum.request({ method: "eth_requestAccounts" }))[0];
      // const accountAddress = "0xeF8dC9479B426b5457057cebb031FA3DC7675520";
      setWeb3Sender(provider);
      setCurrentConnectedWallet(WALLET_IDS.METAMASK);
      dp(updateAccInfo(accountAddress, eq)).then(() => eq("Connect success!", SUCCESS_TOP_CENTER));
      // .catch(() => eq("Something went wrong!", ERR_TOP_CENTER));
    } catch (err) {
      console.error(err);
      clearMetaMaskEventListeners();
      eq(JSON.stringify(err.message), ERR_TOP_CENTER);
    } finally {
      hdClosePopup();
    }
  }

  async function hdWalletConnect() {
    if (currentConnectedWallet === WALLET_IDS.METAMASK) {
      clearMetaMaskEventListeners();
    }
    try {
      addWalletConnectEventListeners(dp, eq);
      await provider.enable();
      setWeb3Sender(provider);
      setCurrentConnectedWallet(WALLET_IDS.WALLET_CONNECT);
      dp(updateAccInfo(provider.accounts[0], eq)).then(() => {
        eq("Connect success!", SUCCESS_TOP_CENTER);
      });
    } catch (err) {
      console.error(err);
      clearWalletConnectEventListeners();
      eq(JSON.stringify(err.message), ERR_TOP_CENTER);
    } finally {
      hdClosePopup();
    }
  }

  return (
    <Dialog open={true} onClose={hdClosePopup} style={{ borderRadius: "10px" }}>
      <img src={topImgSrc} alt="" style={{ width: "100%" }} />
      <Box p={2} py={3} maxWidth="450px">
        <Box textAlign="center">
          <Typography variant="h4" style={{ fontSize: 20, fontWeight: 700 }}>
            Choose Wallet
          </Typography>
          <Typography style={{ width: "90%", margin: "auto", fontSize: 14 }}>
            Safely connect to your existing blockchain wallet and directly stake tokens in them.
          </Typography>

          {/* <Typography>Note: You should access the </Typography> */}
        </Box>

        <Box width="100%" border="0.5px solid rgba(65, 69, 97, 0.2)" borderRadius="5px" mt={2}>
          <List disablePadding={true}>
            <ListItem
              divider
              button
              style={{ minHeight: 64, borderTopRightRadius: "5px", borderTopLeftRadius: "5px" }}
              onClick={hdConnectMetaMask}
              disabled={!window.ethereum || isMobile}
            >
              <img src={metamaskLogo} alt="metamask" style={imgStyle} />
              <ListItemText>MetaMask</ListItemText>
              <Tooltip title="For PC">
                <ComputerIcon></ComputerIcon>
              </Tooltip>
            </ListItem>

            <ListItem
              divider
              button
              style={{ minHeight: 64, borderBottomRightRadius: "5px", borderBottomLeftRadius: "5px" }}
              onClick={hdWalletConnect}
            >
              <img src={walletConnectIcon} alt="wallet-connect" style={imgStyle} />
              <ListItemText>WalletConnect</ListItemText>
              <Tooltip title="For Mobile">
                <PhoneIphoneIcon></PhoneIphoneIcon>
              </Tooltip>
            </ListItem>
          </List>
        </Box>

        <Box mt={2}>
          <Typography align="center" variant="body1" style={{ color: "#AAB8C1", fontSize: "0.75rem" }}>
            By connecting, I accept Trava&#39;s <br></br>
            <a href="https://trava.finance/terms-of-service" target="_blank" rel="noreferrer noopener">
              {" "}
              Terms of Service
            </a>
            ,
            <a href="https://trava.finance/privacy-policy" target="_blank" rel="noreferrer noopener">
              {" "}
              Privacy Policy
            </a>
            , and
            <a href="https://trava.finance/cookies-policy" target="_blank" rel="noreferrer noopener">
              {" "}
              Cookies Policy
            </a>
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
}
